import React, { Component } from 'react'
import { Form, Input, Button, Alert, Tooltip } from 'antd'
import { api } from '../../../../services'

class ConfirmForm extends Component {
  state = {

    error: {
      status: false,
      message: null,
      confirmDirty: false
    },
    success: false,
    data: null
  }

  componentDidMount () {
    const { token } = this.props

    api.user.identifyUserByToken(token)
      .then((response) => {
        this.setState({
          data: response.data.result
        })
      })
      .catch(error => {
        this.setError({
          status: true,
          message: error.response.data.error.message
        })
      })
  }

  setError = (payload) => {
    this.setState({
      error: payload
    })
  }

  handleSubmit = (e) => {
    const { form, token } = this.props

    e.preventDefault()

    form.validateFields((err, values) => {
      if (!err) {
        this.setError({
          status: false,
          message: null
        })
        api.user.confirmUser(token, values.password)
          .then((response) => {
            this.setState({
              success: true,
              data: null
            })
          })
          .catch((response) => {
            this.setError({
              status: true,
              message: response.data.error.message
            })
          })
      }
    })
  }

  handleReset = () => {
    const { form: { resetFields } } = this.props
    resetFields()
  }

  handleConfirmBlur = (e) => {
    const { confirmDirty } = this.state
    const value = e.target.value
    this.setState({ confirmDirty: confirmDirty || !!value })
  }

  validateToNextPassword = (rule, value, callback) => {
    const { confirmDirty } = this.state
    const { form: { validateFields } } = this.props

    if (value && confirmDirty) {
      validateFields(['repeatPassword'], { force: true })
    }
    callback()
  }

  compareToFirstPassword = (rule, value, callback) => {
    const { form: { getFieldValue } } = this.props

    if (value && value !== getFieldValue('password')) {
      const msg = 'Passwords are inconsistent'
      callback(msg)
    } else {
      callback()
    }
  }

  render () {
    const { error, success, data } = this.state
    const { form: { getFieldDecorator } } = this.props

    return (
      <Form onSubmit={this.handleSubmit} className='form form_center'>

        <h3>Password Setup</h3>

        { error.status ? <div className='form__error'>{ error.message }</div> : null }
        { success ? <Alert message='User verified' type='success' /> : null }

        { data === null
          ? <div />
          : <div>

            <div className='confirm-user'>
              <div className='confirm-user__row'>
                <span className='confirm-user__item'>First Name:</span>
                <span className='confirm-user__item'>
                  <Tooltip title={data.firstName} placement='topLeft'>
                    { data.firstName }
                  </Tooltip>
                </span>
              </div>
              <div className='confirm-user__row'>
                <span className='confirm-user__item'>Last Name:</span>
                <span className='confirm-user__item'>
                  <Tooltip title={data.lastName} placement='topLeft'>
                    { data.lastName }
                  </Tooltip>
                </span>
              </div>
              <div className='confirm-user__row'>
                <span className='confirm-user__item'>Email:</span>
                <span className='confirm-user__item'>
                  <Tooltip title={data.email} placement='topLeft'>
                    { data.email }
                  </Tooltip>
                </span>
              </div>
            </div>

            <Form.Item>
              {getFieldDecorator('password', {
                rules: [{ required: true,
                  message: 'Please input your password',
                  max: 320
                }, {
                  validator: this.validateToNextPassword
                }]
              })(
                <Input type='password' name='password' placeholder='Password' />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator('repeatPassword', {
                rules: [{
                  required: true, message: 'Please repeat your password'
                }, {
                  validator: this.compareToFirstPassword
                }]
              })(
                <Input type='password' onBlur={this.handleConfirmBlur} placeholder='Repeat Password' />
              )}
            </Form.Item>

            <Form.Item>
              <Button type='indigo' htmlType='submit' className='login__button'>Save password</Button>
            </Form.Item>
          </div> }

      </Form>
    )
  }
}

export default Form.create()(ConfirmForm)



// WEBPACK FOOTER //
// ./src/views/Confirm/components/ConfirmForm/ConfirmForm.jsx